import useAltKeyDown from "./useAltKeyDown";
import usePresentSelector from './usePresentSelector';
import { ANNOTATIONS } from './RecordTypes';
import SimplePopover from './SimplePopover';
import { FocusedAnnotationContext } from './Contexts';
import LineSegmentBox from './LineSegmentBox';
import { useContext, useEffect, useState, useRef } from 'react';
import { useDispatch} from 'react-redux';
import A from './ActionCreators';
import C from './Constants';
import G from './Getters';
import LineSegment from './LineSegment';
import GuidelineDrawingLayer from './GuidelineDrawingLayer';
import { simpleLeastSquares, distance, scale, unitPerp, add, pointProjectionOntoLine } from './Geometry';
import Scatter from './Scatter';
const bounds = ref => ref && ref.current && ref.current.getBoundingClientRect();
const rectCentroid = bounds => {

}

const __custom = "__custom";


// Example usage

/*
const { slope, intercept } = getBestFitLine(points);
console.log(`Slope: ${slope}`);
console.log(`Intercept: ${intercept}`);
*/


export default function RotationContainerSvg({
  atns,
  highlight,
  notifyAnnotationPropertyChange,
  temporaryAnnotationProperties,
  imgRef,
  imgContainerBounds, 
  cropId, 
  imageSetId,
  interactive,
  //crop,
  imageViewTransformation,
  onEvent,

}){


  const altDown = useAltKeyDown();

  let { focusedAnnotationId, setFocusedAnnotationId } = useContext(FocusedAnnotationContext);


  let imageSetHeight = usePresentSelector(state => G.getImageSetHeight(state,imageSetId));

  let sortedHeightGroups = usePresentSelector(G.getOrderedHeightGroups);

  let [popoverLocation,setPopoverLocation] = useState(null);
  const [hoveredHeight,setHoveredHeight] = useState(null);

  const [lastCreatedAnnotationId,setLastCreatedAnnotationId] = useState(null);

  let focusedAnnotation = usePresentSelector(state => focusedAnnotationId && G.getData(state,{type:ANNOTATIONS,_id:focusedAnnotationId, ifDoesNotExist:null}));


    



  let anchorPosition;
  if(popoverLocation){
    anchorPosition = {
      top:popoverLocation.top - imgContainerBounds.top,
      left:popoverLocation.left - imgContainerBounds.left
    }
  }else{
    anchorPosition = {
      left: 10,
      top: 10
    }
  }


  let reduxDispatch = useDispatch();
  let dispatch = action => {
    reduxDispatch(action);
    onEvent?.(action);
  }

  let imgRefBounds = imgContainerBounds;
  let defaultCropHeightGroupId = sortedHeightGroups[0]?._id || __custom;


  let imageAnnotations = atns;

  //;


  let w = imgRefBounds.width;

  let [ drawing, setDrawing ] = useState(false);
  let annotationComponents;
  const onAnnotationDelete = (deletedAnnotationId) => {
    if( lastCreatedAnnotationId === deletedAnnotationId ){
      setLastCreatedAnnotationId(null);
    }
    let actionArgs= {_id:deletedAnnotationId}
    dispatch(A.deleteAnnotation(actionArgs))

    


    setFocusedAnnotationId(null);
  }


  

  let lineSegmentBoxStyle = !interactive? {stroke:'blue',strokeWidth:1} : {stroke:'blue', strokeOpacity:0.2};


  if( imgRefBounds.width ){

    annotationComponents = imageAnnotations.map(atn =>   (
      <g style={{pointerEvents:(drawing===true)?'none':'unset'}}>
        {!altDown && atn.ls && (
          <LineSegmentBox {...{
            temporaryAnnotationProperties,
            imageSetHeight,
            imageViewTransformation,
            notifyAnnotationPropertyChange,
            annotationId:atn._id,
            annotation:atn,
            setFocusedAnnotationId,
            onDelete:onAnnotationDelete,
            interactive,
            focusedAnnotationId,
            focusedAnnotation:atn,
            height:getAnnotationHeight(atn,sortedHeightGroups,w),
            w,
            imageContainerBounds:imgContainerBounds,
            ...lineSegmentBoxStyle,
            strokeWidth:(focusedAnnotationId === atn._id) ? 4 : 2

          }}/>
        )}
        {atn.mark && (
          <LineSegment setFocusedAnnotationId={setFocusedAnnotationId} highlight={highlight} isFocusedAnnotation={atn._id === focusedAnnotationId} onDelete={onAnnotationDelete} key={atn._id} annotation={atn} imgWidth={imgRefBounds.width} lsStyle={"box"}/>)}
      </g>
    ))
  }

  let lastCreatedAnnotation = usePresentSelector(state => lastCreatedAnnotationId && G.getData(state,{type:ANNOTATIONS,_id:lastCreatedAnnotationId}));
  let points = {};
  let lastCreatedAnnotationIsLineSegment = lastCreatedAnnotation && lastCreatedAnnotation.ls;

  if( lastCreatedAnnotationIsLineSegment ){
    points = {
      start:scale(w,lastCreatedAnnotation.ls[0]),
      end:scale(w,lastCreatedAnnotation.ls[0]),
    }
  }



  let selectedHeight = focusedAnnotation && focusedAnnotation.ls && getAnnotationHeight(focusedAnnotation);







  let shouldShowGuidelineDrawingLayer = (
    interactive !== false && 
    !window.someComponentIsDragging 
    //&& showGuidelines
  )

  if( !imgContainerBounds ){
    debugger;
  }

 return imgContainerBounds && (
    <>

      

      <div id={"redbeard"} container={"image-annotation"} style={{overflow:'visible',position:'absolute',width:imgContainerBounds.width,height:'100%'}}>

        <svg
          id="annotation-container-svg"
          height={imgContainerBounds.height}
          width={imgContainerBounds.width}
          viewBox={`0 0 ${imgContainerBounds.width} ${imgContainerBounds.height}`}
          style={{
            zIndex:10,
            overflow:'visible',
            top: 0, 
            left: 0,
            background: "none",
            position: "absolute",

            //transform:'scaleX(-1)',
          }}>

          <pattern id="stripePattern" width="10" height="10" patternUnits="userSpaceOnUse">
    <rect width="10" height="10" fill="transparent" />
    <line x1="0" y1="0" x2="100" y2="100" stroke="red" strokeWidth="2" />
  </pattern>



          


          {shouldShowGuidelineDrawingLayer && <GuidelineDrawingLayer {...{
            onEvent,
            imageViewTransformation,
            imageSetHeight,
            interactive,
            heightGroupList:sortedHeightGroups,
            selectedHeight,
            defaultCropHeightGroupId,
            setLastCreatedAnnotationId,
            setPopoverLocation,
            lastCreatedAnnotation,
            focusedAnnotationId,
            temporaryAnnotationProperties,
            setDrawing,
            setFocusedAnnotationId,imageSetId,imgContainerBounds,imgRefBounds
          }}/>}       

          {annotationComponents}

          {/*markCircles*/}

          

        </svg>
      </div>

        { focusedAnnotation && focusedAnnotation.ls && anchorPosition && <SimplePopover 
          key={"popover-"+focusedAnnotationId}

          {...{
            w,
            heightGroupList:sortedHeightGroups,
            temporaryAnnotationProperties,
            onAnnotationDelete,
            handleClose:(()=>{ 
              setFocusedAnnotationId(null); 
              setPopoverLocation(null);
            }),
            notifyAnnotationPropertyChange,
            cropId,
            setFocusedAnnotationId,
            focusedAnnotation,
            anchorPosition,
            setAnchorPosition:setPopoverLocation,
            hoveredHeight,
            setHoveredHeight,
          }}/> }


    </>
  )
}

function getAnnotationHeight(atn,sortedHeightGroups,w){

    let height;
    if( atn ){
      let {heightGroupId} = atn;
      if( heightGroupId === __custom ){
        height = atn.height * w;
      }else{
        height = sortedHeightGroups.find(gr => gr._id ===  heightGroupId ).height * w;
      }
    }
    return height;
  }

